<template>
  <div class="head-content">
    <div class="head"  v-if="isMaxScreen">
      <img src="../../assets/image/logo.png" alt="" class="logo">
      <ul class="tab">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          :class="['tab-item', headIndex === index ? 'active' : '']"
          @click="changeIndex(index, item)"
          @mouseenter="enter(index, 'enter')"
          @mouseleave="enter(index, 'leave')"
        >
          <span :class="[headIndex === index ? 'active-block' : '', headIndex === 0 ? 'first-active' : '']">{{item.name}}</span>
          <span class="activeLine" v-show="headIndex === index"></span>
          <div class="code">
            <div class="code-content" v-show="item.codeUrl && codeIndex === index">
              <div class="triangle"></div>
              <div class="codes">
                <img :src="item.codeUrl" alt="">
                <p>{{codeText}}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <van-tabs swipe-threshold='4' :line-width='0' :line-height='0' @click="changeIndexs" :before-change='beforeChange' v-else v-model="headIndex">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item.name"></van-tab>
    </van-tabs>
    <!-- <div :class="['head']" v-else>
      <ul :class="['tab', itemIndex === 4 ? 'tranfer' : '', itemIndex === 0 ? 'tranfer0' : '']">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          class="tab-item"
          @click="changeIndex(index, item)"
        >
          <span :class="[itemIndex === index ? 'active-block' : '', itemIndex === 0 ? 'first-active' : '']">{{item.name}}</span>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '../../store/index'
import { sendSensorsMessage } from '../../utils/sensors'
export default {
  data () {
    return {
      tabList: [
        {
          name: '首页',
          url: '/home',
          type: 1,
          sendSensorsName: 'dhgwsy'
        },
        {
          name: '小当回收',
          url: 'https://cqdanghuan.com/static/index.html#/?channelId=0040963',
          type: 2,
          codeUrl: require('../../assets/image/head/xiaodanghuishou.png'),
          sendSensorsName: 'dhgwxdhsd'
        },
        {
          name: '小当竞拍',
          url: 'https://www.xiaodangjingpai.com',
          type: 2,
          codeUrl: require('../../assets/image/head/xiaodangjingpai.png'),
          sendSensorsName: 'dhgwxdjpd'
        },
        {
          name: '小当严选',
          url: 'http://www.xiaodangyanxuan.com',
          type: 2,
          codeUrl: require('../../assets/image/head/xiaodangyanxuan.png'),
          sendSensorsName: 'dhgwxdyxd'
        },
        {
          name: '小当易换',
          url: '/xdyh',
          type: 1,
          codeUrl: require('../../assets/image/head/xiaodangyihuan.jpg'),
          sendSensorsName: 'dhgwxdyhd'
        },
        {
          name: '关于我们',
          url: '/about',
          type: 1,
          sendSensorsName: 'dhgwgywm'
        }
      ],
      // itemIndex: store.state.headIndex,
      // 展示二维码
      showCode: false,
      codeIndex: 0,
      // 二维码内文字
      codeText: ''
      // active: store.state.headIndex
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
      headIndex: state => {
        return state.headIndex
      }
    })
  },
  methods: {
    // 埋点
    sendSensorsMessage(name) {
      sendSensorsMessage(name, {})
    },
    // pc端切换tab
    changeIndex (index, item) {
      this.sendSensorsMessage(item.sendSensorsName)
      if (item.type === 1) {
        // this.headIndex = index
        this.$router.push(item.url)
        store.dispatch('toggleIndex', index)
      } else {
        if (item.url) {
          window.open(item.url)
          this.showCode = true
        }
        // store.dispatch('toggleIndex', this.headIndex)
      }
      // this.itemIndex = item.type === 1 ? index : this.itemIndex
      // item.type === 1 ? this.$router.push(item.url) : window.open(item.url)
      // store.dispatch('toggleIndex', true)
    },
    // tab鼠标移入移出
    enter (index, type) {
      if (this.isMaxScreen) {
        if (type === 'leave') {
          this.codeIndex = null
          return
        }
        this.codeIndex = (index !== 0 && index !== 5) ? index : null
        this.codeText = index === 1 ? '关注小当回收公众号' : index === 2 ? '关注小当竞拍公众号' : index === 3 ? '下载小当严选APP' : '下载小当易换APP'
        this.showCode = !this.showCode
      }
    },
    // 移动端切换tab
    changeIndexs (name) {
      const item = this.tabList[name]
      const index = Number(item.type) === 1 ? name : this.headIndex
      store.dispatch('toggleIndex', index)
      // this.headIndex = Number(item.type) === 1 ? name : this.active
      if (item.type === 1) {
        this.$router.push(item.url)
      } else if (item.type === 2) {
        window.open(item.url)
      }
      // item.type === 1 ? this.$router.push(item.url) : window.open(item.url)
    },
    beforeChange (index) {
      if (Number(index) === 1 || Number(index) === 2 || Number(index) === 3) {
        return false
      } else {
        return new Promise((resolve) => {
          // 在 resolve 函数中返回 true 或 false
          resolve(index !== 4 && index !== 0)
        })
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const index = window.location.hash.includes('about') ? 4 : 0
      if (this.isMaxScreen) {
        store.dispatch('toggleIndex', index)
      } else {
        store.dispatch('toggleIndex', index)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  ::-webkit-scrollbar {
    width: 0px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .head {
    width: 100%;
    // width: 500px;
    // width: 855px;
    height: 88px;
    overflow-y: scroll;
    background: #F2F5F8;
    .tab {
      width: 855px!important;
      // width: 100%;
      height: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      // transition: transform .5s;
      .tab-item {
        width: 168px;
        height: 100%;
        line-height: 88px;
        font-size: 24px;
        .active-block {
          display: inline-block;
          width: 150px;
          height: 60px;
          line-height: 60px;
          background: #FF9600;
          border-radius: 30px;
          color: white;
        }
        .first-active {
          width: 120px;
        }
      }
    }
    .tranfer0 {
      // width: 855px;
      transform: translateX(0px);
      transition: transform .5s;
      overflow-y: scroll!important;
      z-index: 999;
    }
    .tranfer {
      // width: 855px;
      // width: 100%;
      transform: translateX(-106px);
      transition: transform .5s;
      overflow-y: scroll!important;
      z-index: 999;
    }
    // .tranfer {
    //   margin-left: -106px;
    //   transition: margin 0.5s ease-out;
    //   -webkit-transition: margin 0.5s ease-out;
    //   -moz-transition: margin 0.5s ease-out;
    //   -khtml-transition: margin 0.5s ease-out;
    //   overflow-y: scroll;
    //   position: fixed;
    //   right: 0px;
    // }
  }
  /deep/.van-tabs {
    width: 100%;
    // width: 855px;
    height: 88px;
  }
  /deep/.van-tabs__nav {
    margin: 0;
    padding: 0;
    background: #F2F5F8;
    display: flex;
    align-items: center;
  }
  /deep/.van-tabs__wrap {
    width: 100%;
    height: 100%;
  }
  /deep/.van-tab {
    width: 162px!important;
    padding: 0!important;
    margin: 0!important;
  }
  /deep/.van-tab--active:first-child .van-tab__text{
    display: inline-block;
    width: 120px!important;
    height: 60px;
    line-height: 60px;
    background: #FF9600;
    border-radius: 30px;
    color: white;
  }
  /deep/.van-tab__text {
    font-size: 28px;
  }
  /deep/.van-tab--active .van-tab__text{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px!important;
    height: 60px;
    line-height: 60px;
    background: #FF9600;
    border-radius: 30px;
    color: white;
  }
  /deep/.van-tabs__nav .van-tab:first-child {
    margin-right: 0px!important;
  }
  /deep/.van-tabs__nav .van-tab:nth-child(5) {
    width: 198px!important;
    padding-right: 30px;
    box-sizing: border-box;
  }
}
@media (min-width: 981px) {
  .head-content {
    background: #fff;
  }
  .head {
    width: 1200PX!important;
    height: 80PX!important;
    line-height: 80PX;
    margin: 0 auto;
    // padding: 0 250PX;
    // box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 108PX;
      height: 40PX;
    }
    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      .tab-item {
        color: #333;
        list-style: none;
        width: 160PX;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .activeLine {
          width: 30PX;
          height: 4PX;
          background: #FF9600;
          border-radius: 2PX;
          position: absolute;
          top: 58PX;
          left: 65PX;
        }
        .code {
          width: 150PX;
          position: absolute;
          top: 70PX;
          z-index: 99999!important;
          .code-content {
            width: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            .triangle {
              // width: 0;
              // height: 0;
              // border-bottom: 12PX solid white;
              // border-right: 12PX solid transparent;
              // border-left: 12PX solid transparent;
              width: 0PX;
              height: 0PX;
              border-width: 12PX;
              border-style: solid;
              border-color: transparent transparent #FFF transparent;
            }
            .codes {
              width: 100%;
              height: 172PX;
              background: white;
              border-radius: 6PX;
              // box-shadow: 0PX 2PX 20PX 0PX rgba(0, 0, 0, 0.1);
              padding: 14PX 13PX 0 13PX;
              box-sizing: border-box;
              margin: 0;
              img {
                width: 124PX;
                height: 124PX;
                margin-bottom: 7PX;
              }
              p {
                margin: 0;
                margin-top: -35PX;
                font-size: 12PX;
                color: #666;
                line-height: 12PX;
              }
            }
          }
        }
        span {
          font-size: 16PX;
        }
      }
      .active {
        color: #111;
        font-weight: bold;
      }
    }
  }
}
</style>
